import { compose, toClass } from 'recompose';
import { withAnimationContextProvider } from '../../withAnimationContext';
import ActivityChartRow from '../ActivityScene/ActivityChart/ActivityChartRow';
import LazyActivityMap from '../ActivityScene/ActivityMap/LazyActivityMap';
import { createActivityMapAndChartContainer } from '../ActivityScene/ActivityMapAndChartContainer';
import {
    ActivityInput,
    ActivityMapContainerProps,
    AthleteProps,
    SaveAthleteOptionsProps
} from '../types';
import {
    withDemoChartStreams,
    withDemoMapStreams
} from './withDemoActivityStreams';
import { withDemoSaveAthleteOptions } from './withDemoSaveAthleteOptions';

const DemoActivityMapWithData = compose<any, ActivityMapContainerProps>(
    withDemoMapStreams
)(LazyActivityMap);

const DemoActivityChartRowWithData = compose<any, any>(
    toClass,
    withDemoChartStreams
)(ActivityChartRow);

const DemoMapAndChartContainer = createActivityMapAndChartContainer(
    DemoActivityMapWithData,
    DemoActivityChartRowWithData
);

export default compose<
    ActivityInput & AthleteProps & SaveAthleteOptionsProps,
    ActivityInput
>(withDemoSaveAthleteOptions, withAnimationContextProvider)(
    DemoMapAndChartContainer
);



// WEBPACK FOOTER //
// ./src/client/components/Strava/Demo/DemoActivityMapAndChartContainer.tsx